import {
  Navigate,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { Suspense, lazy } from "react";
import { ConfirmProvider } from "hooks/confirm/confirm.provider";
import ErrorFallback from "components/error/ErrorFallback";

const AdminLayout = lazy(() => import('layouts/admin'));
const AuthLayout = lazy(() => import('layouts/auth'));
const WarningLayout = lazy(() => import('layouts/warning'));
const VoiceLayout = lazy(() => import('layouts/voice'));

const router = createBrowserRouter([
  {
    path: "auth/*",
    element: <AuthLayout />,
    errorElement: <ErrorFallback />,
  },
  {
    path: "admin/*",
    element: <AdminLayout />,
    errorElement: <ErrorFallback />,
  },
  {
    path: "server/*",
    element: <WarningLayout />,
    errorElement: <ErrorFallback />,
  },
  {
    path: "voice/*",
    element: <VoiceLayout />,
    errorElement: <ErrorFallback />,
  },
  {
    path: "/",
    element: <Navigate to="/auth" replace />,
    errorElement: <ErrorFallback />,
  },
]);
const App = () => {
  return (
    <ConfirmProvider>
      <Suspense fallback={<div></div>}>
        <RouterProvider router={router} />
      </Suspense>
    </ConfirmProvider>

  );
};

export default App;
